import {
  AbTestDataFragment,
  AbTestFragment,
} from '@spotify/confidence-graphql';
import { MetricsData } from '@spotify/plugin-confidence-metrics-react';
import { getIsEditDisabled } from '@spotify/plugin-confidence-workflows-react';

export const isEditDisabled = getIsEditDisabled(['ended', 'live', 'archived']);

export const isEditAllocationDisabled = (
  instance?: Maybe<{ state: string }>,
) => {
  return (
    instance?.state?.includes('ended') || instance?.state?.includes('archived')
  );
};

export const tabForState = (
  workflowInstance: Pick<AbTestFragment, 'state' | 'stateHistory'>,
) => {
  const { state, stateHistory } = workflowInstance;

  // If the workflow has been live at some point, we want to show the result page
  // as default page.
  const wasLive = stateHistory?.some(e => e.state === 'live');
  const standard =
    state === 'live' || state === 'ended' || (state === 'archived' && wasLive)
      ? 'result'
      : 'design';
  return standard;
};

export const getCalculateSampleSizeDisabledReason = (
  state: string,
  abtestData: AbTestDataFragment,
  metricsData?: MetricsData,
) => {
  if (state === 'ended' || state === 'archived') {
    return 'Sample size calculation is not available for ended experiments';
  }

  if (!abtestData?.flag) {
    return 'You must select a flag before calculating the required sample size';
  }

  if ((abtestData?.treatments?.length ?? 0) < 2) {
    return 'You must select at least two treatments before calculating the required sample size';
  }

  if (abtestData?.treatments?.some(t => t.weight === 0)) {
    return 'You must give each treatment a non-zero allocation before calculating the required sample size';
  }

  if (!metricsData?.metrics.some(m => !m.surfaceOnly)) {
    return 'You must add at least one non-required metric to the experiment before calculating the required sample size';
  }
  return undefined;
};
